import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgSftpIntegrationSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type OrgSftpIntegrationSidebarQuery = { __typename?: 'Query', OrgSftpIntegration?: { __typename?: 'OrgSftpIntegration', id: string, createdAt: string, updatedAt: string, filePath?: string | null, slug?: string | null, syncTimes: Array<string>, employeeIdField: string, firstNameField: string, firstNameFallbackField?: string | null, lastNameField: string, lastNameFallbackField?: string | null, phoneField?: string | null, phoneFallbackField?: string | null, startDateField: string, terminationDateField?: string | null, locationField?: string | null, teamField?: string | null, org: { __typename?: 'Org', id: number }, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null, remoteSftpCsvFiles: Array<{ __typename?: 'RemoteSftpCsvFileMetadata', fileName: string, key: string, uploadedAt: string, size: number }> } | null };


export const OrgSftpIntegrationSidebarDocument = gql`
    query OrgSftpIntegrationSidebar($id: UUID!) {
  OrgSftpIntegration(id: $id) {
    id
    createdAt
    updatedAt
    filePath
    slug
    syncTimes
    employeeIdField
    firstNameField
    firstNameFallbackField
    lastNameField
    lastNameFallbackField
    phoneField
    phoneFallbackField
    startDateField
    terminationDateField
    locationField
    teamField
    org {
      id
    }
    locationGroup {
      id
      name
    }
    remoteSftpCsvFiles {
      fileName
      key
      uploadedAt
      size
    }
  }
}
    `;

/**
 * __useOrgSftpIntegrationSidebarQuery__
 *
 * To run a query within a React component, call `useOrgSftpIntegrationSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSftpIntegrationSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSftpIntegrationSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrgSftpIntegrationSidebarQuery(baseOptions: Apollo.QueryHookOptions<OrgSftpIntegrationSidebarQuery, OrgSftpIntegrationSidebarQueryVariables> & ({ variables: OrgSftpIntegrationSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgSftpIntegrationSidebarQuery, OrgSftpIntegrationSidebarQueryVariables>(OrgSftpIntegrationSidebarDocument, options);
      }
export function useOrgSftpIntegrationSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgSftpIntegrationSidebarQuery, OrgSftpIntegrationSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgSftpIntegrationSidebarQuery, OrgSftpIntegrationSidebarQueryVariables>(OrgSftpIntegrationSidebarDocument, options);
        }
export type OrgSftpIntegrationSidebarQueryHookResult = ReturnType<typeof useOrgSftpIntegrationSidebarQuery>;
export type OrgSftpIntegrationSidebarLazyQueryHookResult = ReturnType<typeof useOrgSftpIntegrationSidebarLazyQuery>;
export type OrgSftpIntegrationSidebarQueryResult = Apollo.QueryResult<OrgSftpIntegrationSidebarQuery, OrgSftpIntegrationSidebarQueryVariables>;